module.exports = __webpack_public_path__ + "img/color_autumn_clothes.5ef9ada4.png";